export enum UrlModalParam {
    Open = "open",
    For = "for"
}

export enum UrlModalType {
    Waitlist = "waitlist"
}

export { WaitlistFeature } from "@/contexts/WaitlistContext";
